export default "__VITE_ASSET__0807e111__"